export default {
  SET_BALANCES(state, payload) {
    state.balance = payload
  },

  SET_BALANCES_ORIGIN(state, payload) {
    state.balanceOrigin = payload
  },

  SET_CHANNELS_BALANCES(state, payload) {
    state.totalsBalanceChannels = payload
  },

  SET_CHANNELS_BALANCES_ORIGIN(state, payload) {
    state.totalsBalanceChannelsOrigin = payload
  },

  ADD_LINE(state, payload) {
    //TODO atualizar com BD
    const INDEX = state.balance.findIndex((item) => item.channel == payload.data._channel)
    state.balance[INDEX][payload.table].push(payload.data)
  },

  REMOVE_LINE_BALANCE(state, payload) {
    //TODO atualizar com BD
    state.balance[payload.channel].currentBalances = state.balance.channels[payload.channel].currentBalances.filter((item) => item.id != payload.id)
  },

  REMOVE_REGISTER(state, payload) {
    // atualizar lista local
    state.balance.forEach((item) => {
      if (payload.item._channel == item.channel) {
        const index = item[payload.item._typeTable].findIndex((el) => el._tempId == payload.item._tempId)
        item[payload.item._typeTable].splice(index, 1)
      }
    })
  },

  MESSAGE_REQUEST(state, payload) {
    state.balance.forEach((item) => {
      if (payload._channel == item.channel) {
        const index = item[payload._typeTable].findIndex((el) => {
          if (el.index == payload.index) return el

          if (el.id == payload.id) return el

          if (el._tempId == payload.id) return el
        })

        item[payload._typeTable][index]._message = payload._message
      }
    })
  },

  CLOSE_ALL_MODAL(state, payload) {
    state.balance.forEach((item) => {
      if (payload.all) {
        item.currentBalances.forEach((el) => {
          el._modalChangeValue = false
          el._modalDelete = false
        })
        item.recurrentAddOns.forEach((el) => {
          el._modalChangeValue = false
          el._modalDelete = false
        })
      } else {
        item.currentBalances.forEach((el) => {
          el[payload.modal] = false
        })
        item.recurrentAddOns.forEach((el) => {
          el[payload.modal] = false
        })
      }
    })
  },

  TOGGLE_MODAL(state, { item, modal, type }) {
    state.balance.forEach((BALANCE) => {
      if (item._channel == BALANCE.channel) {
        BALANCE[item._typeTable].filter((el) => {
          // dados em BD
          if (el.id) {
            if (el.id == item.id) {
              el[modal] = !el[modal]
              el._modalTypeValueActive = type
            }

            return
          }

          // dados locais

          if (el._tempId == item._tempId) {
            el[modal] = !el[modal]
            el._modalTypeValueActive = type
          }
        })
      }
    })
  },

  UPDATE_LINE(state, payload) {
    //TODO atualizar com BD
    state.balance.channels[payload.channel].currentBalances.forEach((item) => {
      if (item.id == payload.id) {
        item.currentBalance = payload.updateLineBalace
        item.reason = payload.reason
      }
    })
  },

  TOGGLE_SWITCH_CHANNEL(state, payload) {
    state.balance.channels[payload.channel].state = payload.state
  },

  RESET_BALANCE(state) {
    state.totalsBalanceChannels = [
      {
        channel: 'email',
        currentBalance: 0,
      },
      {
        channel: 'sms',
        currentBalance: 0,
      },
    ]
    state.totalsBalanceChannelsOrigin = [
      {
        channel: 'email',
        currentBalance: 0,
      },
      {
        channel: 'sms',
        currentBalance: 0,
      },
    ]
    state.balance = {}
    state.balanceOrigin = {}
  },
}
